// Local imports
import { basePath } from "./next.config";

// Put base bath before image assets in public directory
module.exports = function (source) {
  return basePath ? `${basePath}${source.src}` : `${source.src}`;
};
